export enum FilterType {
  String,
  Number,
  DateTime,
  Bool,
  Guid,
  Enum
}
